import React from 'react';
import { FormattedMessage } from 'react-intl';
import { object, string } from 'yup';
import { messages } from './messages';

export const buildSchema = ({ isRequired, isNullable, name, max }) => {
  let schema = string();

  if (isRequired) {
    schema = schema.required(<FormattedMessage {...messages.fieldNameRequired} values={{ name }} />);
  }

  if (isNullable) {
    schema = schema.nullable();
  }

  if (max !== undefined) {
    schema = schema.max(max, ({ value }) => (
      <FormattedMessage
        {...messages.maximumCharactersWithOverage}
        values={{
          b: (chunks) => <b>{chunks}</b>,
          max,
          overage: value.length - max,
        }}
      />
    ));
  }

  return object({ [name]: schema });
};
